import {Editor} from "@tldraw/tldraw";

export interface TaskFlowContextValue {
    snackbarOpen: boolean;
    conversionId: string | null;
    handleSetTaskProcess: (process: taskProcess) => void;
    taskProcess: taskProcess[] | null;
    loading: boolean;
    handleSetPrompt: (topic: string) => void;
    taskListProcess: taskProcessList[] | null;
    updateStatus: (taskId?:number, status?: TaskStatusType, extra?: ExtraProps) => void;
    changeTaskProcess: (taskId: number, status: any) => void;
    conversionValue: ConversionType;
    editor?: Editor,
    conversionHistoryDetail: (taskProcess[] | null)[],
    updateTaskParamsForTaskId: (taskId?: number, extra?: ExtraProps) => void,
    changeLoadingStatus: (loading: boolean) => void;
}

export enum TaskStatusType {
    PENDINGEXECUTION = 'PENDING EXECUTION',
    EXECUTING = 'EXECUTING',
    CONFIRMING = 'CONFIRMING', 
    PENDING = 'PENDING',
    COMPLETED = 'COMPLETED',
    CANCELED = 'CANCELED',
    EXCEPTION = 'EXCEPTION'
}

export enum ConversionType {
    CONVERSING = 0,
    HISTORY = 1,
}

export enum TriggerType {
    ADD_TASK_CARD = 'ADD_TASK_CARD',
    UPDATE_TASK_CARD_STATUS = 'UPDATE_TASK_CARD_STATUS',
    CONVERSION_CREATE = 'CONVERSION_CREATE',
    UPDATE_CONVERSION_STATUS = 'UPDATE_CONVERSION_STATUS',
    SERVER_PUSH_IMAGE = 'SERVER_PUSH_IMAGE',
    UPDATE_STEP_STATUS = 'UPDATE_STEP_STATUS',
    ADD_BATCH = 'ADD_BATCH',
    CONNECT_SUCCESS = 'CONNECT_SUCCESS',
    ADD_SUGGESTION = 'ADD_SUGGESTION',
    LOCK = "LOCK",
    UNLOCK = "UNLOCK",
}

export enum CommandType {
    GET_CONVERSION_ID = 'getConversionId',
    SEND_PROMPT = 'sendPrompt',
    ANALYSIS = 'analysis',
    EXECUTE_TASK = 'executeTask',
    GENERATE_TAGS = 'generateTags',
    FETCH_IMAGES = 'fetchImages',
    GENERATE_IMAGES = 'generateImages',
    GENERATE_PLANS = 'generatePlan',
    EDIT_IMAGES = 'editImages',
    PARSER_TASK_CARD = 'parserTaskCard',
    PUSH_IMAGES = 'pushImages',
    CHAT = 'chat',
    BATCH = 'batch',
    GEN_SUGGESTIONS = 'genSuggestions'
}

export type ResponseProp = analysisTaskProcess | AskTaskProcess | GenerateTagsTaskProcess | FetchImagesTaskProcess | BatchTaskProcess

export interface ExtraProps {
    checkedImgs?: number[],
    cancelTask?: string[],
    checkedLabels?: number[],
    images?: string[]

}

export interface taskProcess {
    id?: number;
    conversationId?: string,
    cardIdInDify?: string,
    role?: string,
    content?: string,
    response: ResponseProp,
    triggerCmd: CommandType,
    createdAt?: string,
    status: TaskStatusType,
    extra?: ExtraProps
    stepId?: string,
    batchId?: string
}

export interface taskProcessStatus {
    toolName: CommandType,
    status: TaskStatusType
}

export interface taskProcessList {
    id: number,
    conversationId: string,
    clientId: string,
    status: 'active' | 'inactive',
    createdAt: string
}

export interface AskTaskProcess {
    prompt: string;
    content: string
}

export interface GenerateTagsTaskProcess {
   note: string;
   data: string[];
}

export interface FetchImagesSubTaskProcess {
    description: string;
    note: string;
    tags: string[];
    url: string;
    width?: number;
    height?: number;
    lod0?: string;
    lod1?: string;
    lod2?: string;
    uuid?: string;
    isCenter?: boolean;
    groupId?: number
    taskId?: number
}

export interface BatchSubTaskProcess {
    stepId: string,
    totalCards: number,
    type: "horizontal" | "vertical",
    cardIdsInDify: string[]
}

export interface FetchImagesTaskProcess {
    note: string;
    data: FetchImagesSubTaskProcess[];
}

export interface BatchTaskProcess {
    note: string;
    data: BatchSubTaskProcess
}

export interface AnalysisTaskSubProcess {
    toolName: string,
    parameters: any
    note: string
}

export type suggestionProps =  "onBoardInit" | "onFocusStep" | "onFocusCard" | "onFocusImage"

export interface analysisTaskProcess {
    note: string,
    data: AnalysisTaskSubProcess[]
}

export interface GetImagesParams {
    uuid: string,
    extra: any
}

export interface TaskState {
    dialogImageInfo: FetchImagesSubTaskProcess | null,
    level2TaskId: number | null,
    canvasImage: string[] | null,
    snackbarOpen: {open: boolean, message: string},
    globalMessage: string
}

export interface currentTaskCacheProps {
    icon?: TaskStatusType,
    template?: JSX.Element,
    task: AnalysisTaskSubProcess,
    index: number,
    content?: string,
    count: number,
    color: string,
    status?: TaskStatusType
}